module.exports = __webpack_public_path__ + "static/img/myntra.5197a590.png";